import { Box } from '@mui/material';
import React from 'react';

import { PageNumberProps } from '@common/types/campaign';
import { CONTROL_SIZE } from '@common/utils/campaignPaginationItems';

/**
 * PageNumber
 *
 * Renders the page number
 * @param page - the page number
 * @param selected - whether the page number is selected
 * @param onClick - the function to call when the page number is clicked
 */
export function PageNumber({
  disabled = false,
  page,
  selected,
  onClick,
}: PageNumberProps): JSX.Element {
  return (
    <Box
      component="button"
      type="button"
      aria-current={selected ? 'page' : undefined}
      aria-label={`Go to page ${page}`}
      disabled={disabled}
      onClick={onClick}
      sx={(theme) => ({
        '&:hover:not(:disabled)': {
          backgroundColor:
            theme.palette?.action?.hover ?? 'rgba(0, 0, 0, 0.04)',
        },
        alignItems: 'center',
        backgroundColor: 'transparent',
        border: selected
          ? `0.5px solid ${theme.colors.primary}`
          : '0.5px solid transparent',
        borderRadius: '50%',
        boxSizing: 'border-box',
        color: selected ? theme.colors.primary : theme.palette?.text?.primary,
        cursor: disabled ? 'default' : 'pointer',
        display: 'inline-flex',
        flexShrink: 0,
        font: 'inherit',
        fontSize: theme.typography.body1.fontSize,
        height: CONTROL_SIZE,
        justifyContent: 'center',
        lineHeight: 1,
        minWidth: CONTROL_SIZE,
        opacity: disabled ? 0.5 : 1,
        padding: 0,
        transition: 'background-color 150ms ease',
        width: CONTROL_SIZE,
      })}
    >
      {page}
    </Box>
  );
}
